<template>
  <Transition
    enter-from-class="-translate-y-full scale-y-0"
    enter-to-class="translate-y-0 scale-y-100"
    :enter-active-class="`transform transition duration-200 ease-out ${delayIn}`"
    leave-from-class="translate-y-0 scale-y-100"
    leave-to-class="-translate-y-full scale-y-100"
    :leave-active-class="`transform transition duration-200 ease-in ${delayOut}`"
    :appear="appear"
  >
    <slot />
  </Transition>
</template>

<script setup lang="ts">
defineProps({
  appear: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  delayIn: {
    type: String as PropType<string>,
    default: '',
  },
  delayOut: {
    type: String as PropType<string>,
    default: '',
  },
})
</script>
